<template>
    <div>
        <el-dialog style="text-align: left;" title="播放视频" :visible.sync="dialogVisible" width="800px" height="480px" :append-to-body="true" :before-close="handleClose">
            <video id="video" :autoplay="true" style="height: 480px;" controls width="800" height="480" :src="videoSrc">
                
            </video>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            dialogVisible: false,
            videoSrc:""
        }
    },
    methods: {
        handleClose() {
            this.dialogVisible = false
            this.videoSrc = ""
            // 关闭弹出框时 视频关闭播放
            const video = document.getElementById('video')
            video.pause()
        },
    }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>